import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=20f6ad72&"
import script from "./UsersTable.js?vue&type=script&lang=js&"
export * from "./UsersTable.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports